// Claim record: a timeline row's "Log" opens that same event in ELVA's work ›
// Log, or nothing. A row only links when the Log has an entry for the same
// patient on the same day; it never borrows another patient's entry (rcm-31 §2).
// Gap: the Log is seeded separately from the claim set, so most rows have no
// match yet. ELVA's work needs its Log seeded from this claim seed.
import { getLogEntriesFlat } from '@/features/elva-work/store';
import type { LogEntry } from '@/features/elva-work/types';

export function logHrefForEntry(patient: string, iso: string | undefined): string | null {
  if (!iso) return null;
  const e = getLogEntriesFlat().find(
    (x: LogEntry) => x.dateIso === iso && (x.what.includes(patient) || (x.title ?? '').includes(patient)),
  );
  return e ? `/elva-work/log/${e.id}` : null;
}
